// extracted by mini-css-extract-plugin
module.exports = {"introContainer":"IntroContainer_introContainer__5I4Ff"};